/**
* 操作日志
*/
<template>
	<div style="display: flex;flex-direction: column; height: 100vh;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>


		<!-- 搜索条件 -->
		<div style="margin: 0 20px; display: flex; margin-top: 20px;">

			<el-form :inline="true" size="mini" label-position="left" style="margin-bottom: -10px;">

				<!-- 日期搜索 -->
				<el-form-item :label="$t('language000475')" style="margin-bottom: 12px; margin-right: 20px;">
					<el-date-picker v-model="value" type="daterange" @change="selectTime"
						:start-placeholder="$t('language000292')" :end-placeholder="$t('language000293')"
						:default-time="['00:00:00', '23:59:59']" style="width: 240px; border-radius: 4px;">
					</el-date-picker>
				</el-form-item>

				<!-- 售后系统登录账号 -->
				<el-form-item :label="$t('language000503')" style="margin-bottom: 12px; margin-right: 20px;">
					<el-input :placeholder="$t('language000503')" v-model="input1" style="width: 240px;"
						clearable></el-input>
				</el-form-item>

				<!-- 用户ID -->
				<el-form-item :label="$t('language000095')" style="margin-bottom: 12px; margin-right: 20px;">
					<el-input :placeholder="$t('language000095')" v-model="input2" style="width: 240px;"
						clearable></el-input>
				</el-form-item>

				<el-button style="margin-left: 5px;" type="primary" icon="el-icon-search" @click="search()">
					<!-- 查询 -->
					{{ $t('language000477') }}
				</el-button>

			</el-form>

		</div>

		<!-- 列表 -->
		<el-table :data="tableData" height="100%" stripe border
			:header-cell-style="{ background: '#f8f9fa', color: '#303133', fontWeight: 'bold' }"
			style="width: 100%; flex: 1; margin-top: 20px;">

			<!-- 序号 -->
			<el-table-column type="index" :index="indexMethod" :label="$t('language000479')" width="60"
				align="center"></el-table-column>

			<!-- 操作时间 -->
			<el-table-column prop="createTime" :label="$t('language000504')" width="240" sortable>
				<template slot-scope="scope">
					<span
						style="color: #606266; font-family: Consolas, Monaco, monospace;">{{ scope.row.createTime }}</span>
				</template>
			</el-table-column>

			<!-- 操作内容 -->
			<el-table-column prop="operateTypeText" :label="$t('language000505')" width="180" align="center">
				<template slot-scope="scope">
					<el-tag
						:type="scope.row.operateCode === 1 ? 'danger' : (scope.row.operateCode === 2 ? 'success' : 'info')"
						size="small" effect="plain">
						{{ scope.row.operateTypeText }}
					</el-tag>
				</template>
			</el-table-column>

			<!-- QIUI用户ID -->
			<el-table-column :label="$t('language000087')" width="240" align="center">
				<template slot-scope="scope">
					<span
						style="background: #F2F6FC; color: #409EFF; padding: 2px 8px; border-radius: 4px; font-weight: 500;">
						{{ scope.row.userId }}
					</span>
				</template>
			</el-table-column>

			<!-- 操作人员 -->
			<el-table-column :label="$t('language000506')" align="center">
				<template slot-scope="scope">
					<div style="display: flex; flex-direction: column; align-items: center; line-height: 1.4;">

						<span style="font-weight: 600; color: #303133; font-size: 14px;">
							{{ scope.row.sysAfterSaleUserAccount }}
						</span>

						<span style="font-size: 11px; color: #909399; margin-top: 2px;">
							ID: {{ scope.row.sysAfterSaleUserId }}
						</span>

					</div>
				</template>
			</el-table-column>

			<!-- 操作人员 -->
			<el-table-column prop="id" :label="$t('language000507')" width="140" align="right">
				<template slot-scope="scope">
					<span style="font-size: 11px; color: #C0C4CC; font-family: Consolas;">#{{ scope.row.id }}</span>
				</template>
			</el-table-column>

		</el-table>

		<!-- 页码 -->
		<div class="block"
			style="flex-shrink: 0; width: 100%; height: 60px; display: flex; align-items: center; justify-content: center;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
				:page-sizes="[20, 30, 40,50,100,200]" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				input1: '', //售后系统登录账号
				input2: '', //被执行人的用户id（app用户id）
				pageSize: 20, //每页条数
				pageNum: 1, //当前页数
				total: 0, //一共有多少条数据
				tableData: null, //列表数据
				//...
			};
		},
		mounted() {
			this.fetchData(this.pageNum, this.pageSize); //日志查询
		},
		methods: {
			fetchData(pageNum, pageSize) { //日志查询

				this.loadingData = true;

				this.pageSize = pageSize;
				this.pageNum = pageNum;

				const requestData = {}; //传递的参数
				requestData.pageSize = pageSize;
				requestData.pageNum = pageNum;

				if (this.startTime > 0) { //开始时间
					requestData.startTime = this.startTime;
				}
				if (this.endTime > 0) { //结束时间
					requestData.endTime = this.endTime;
				}

				if (this.input1.length > 0) { //售后系统登录账号
					requestData.sysAfterSaleUserAccount = this.input1;
				}
				if (this.input2.length > 0) { //被执行人的用户id（app用户id）
					requestData.userId = this.input2;
				}


				axios.post(this.$p_url + '/admin/getOperateRecordList', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("日志查询 数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							const resultData = response.data.data || {}; //安全获取 data 对象
							this.total = resultData.total || 0;
							const list = resultData.list || []; //防御性获取 list，如果 list 为空则赋值为空数组 []，避免 .length 报错

							// 1. 定义映射表，存储语言 Key
							const operateTypeMap = { 
							    1: "language000489", // 对应 "封号" (或你自定义的封禁账号编号)
							    2: "language000490", // 对应 "解封" (或你自定义的解封账号编号)
							};
							
							list.forEach(item => {
							    const code = Number(item.operateType); 
							    const langKey = operateTypeMap[code];
							    
							    // 2. 使用 this.$t 进行实时翻译赋值
							    // 如果找不到 key，则显示“未知操作”，建议“未知”也走多语言
							    item.operateTypeText = langKey ? this.$t(langKey) : (this.$t('language_unknown') + `(${code})`);
							    
							    item.operateCode = code; 
							});

							this.tableData = response.data.data.list;
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			search() { //单击了搜索
				this.fetchData(1, this.pageSize);
			},
			handleSizeChange(val) { //设置每页多少条
				this.pageSize = val;
				this.fetchData(this.pageNum, val);
			},
			handleCurrentChange(val) { //查询第几页的数据
				this.fetchData(val, this.pageSize);
			},
			selectTime() { //选择了时间
				if (this.value == null) {
					this.startTime = 0;
					this.endTime = 0;
					this.fetchData(1, this.pageSize);
				} else {
					[this.startTime, this.endTime] = this.value;
					// 将时间字符串转换为时间戳
					this.startTime = new Date(this.startTime).getTime();
					this.endTime = new Date(this.endTime).getTime();
					this.fetchData(1, this.pageSize);
				}
			},
			formatDate(timestamp) {
				const date = new Date(timestamp);
				// 获取年月日时分秒
				const year = date.getFullYear();
				const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 补0操作
				const day = date.getDate().toString().padStart(2, '0');
				const hours = date.getHours().toString().padStart(2, '0');
				const minutes = date.getMinutes().toString().padStart(2, '0');
				const seconds = date.getSeconds().toString().padStart(2, '0');

				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			indexMethod(index) {
				if (this.pageNum == 1) {
					return index + 1;
				} else {
					return (this.pageNum - 1) * this.pageSize + index + 1;
				}

			},
			//...
		},
		//...
	}
</script>

<style>
	.container {
		display: flex;
		padding: 0px 10px;
	}

	.box {
		flex: 1;
		padding: 15px;
		width: 180px;
		height: 60px;
		margin: 10px;
		border-radius: 20px;
		/* 防止文本溢出 */
		overflow: hidden;
	}
</style>